angular
    .module('backOffice')
    .controller('messageCenterArchiveModalController', messageCenterArchiveModalController);

messageCenterArchiveModalController.$inject = [
    '$scope',
    '$modalInstance',
    'message',
    'messagingCenterService',
];

function messageCenterArchiveModalController(
    $scope,
    $modalInstance,
    message,
    messagingCenterService
) {
    $scope.message = message;

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    $scope.archive = function () {
        messagingCenterService
            .update({
                messageId: message.id,
                actionTypeId: 2,
            })
            .then(() => {
                $modalInstance.close($scope.message);
            });
    };
}
